import { CachedProductType } from '@/app/actions/productTypes';

export const getOneSizeId = (
  productType: AssortmentListProductType | ProductType | CachedProductType | ClientProductType
) => {
  return productType.sizes.length === 1 ? productType.sizes[0]!.id : undefined;
};
